import { Maybe } from "graphql/jsutils/Maybe";
import { TaskTypeDetailInput } from "../../graphql/generated/schema-types";

export const RunTaskTypeCompositeKey = (object: Maybe<TaskTypeDetailInput>) => {
  return `${object?.taskType}${object?.taskTypeId}`;
};
